import { createSelector } from 'reselect';

export const campaignsSelector = (state) => state.campaigns;

export const campaignsObjectsSelector = createSelector(
  campaignsSelector,
  (campaigns) => campaigns.objects,
);

export const categoriesSelector = createSelector(
  campaignsSelector,
  (campaigns) => campaigns.categories,
);

export const campaignsByCategorySelector = createSelector(
  campaignsSelector,
  (campaigns) => campaigns.campaignsByCategory,
);

export const selectedCategoryIdSelector = createSelector(
  campaignsSelector,
  (campaigns) => campaigns.selectedCategoryId,
);
